import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../types/commonTypes";
import { Config } from "../types/configTypes";
import configApi from "../api/configApi";

interface ConfigState {
  loadState: LoadState;
  config?: Config;
}

const initialState: ConfigState = {
  loadState: LoadState.INIT,
  config: {},
};

export const configSlice = createSlice({
  name: "ConfigState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(configApi.endpoints.getConfig.matchPending, (state) => {
        state.loadState = LoadState.LOADING;
      })
      .addMatcher(
        configApi.endpoints.getConfig.matchFulfilled,
        (state, { payload }) => {
          state.loadState = LoadState.LOADED;
          state.config = payload;
        }
      )
      .addMatcher(configApi.endpoints.getConfig.matchRejected, (state) => {
        state.loadState = LoadState.ERROR;
      });
  },
});

export default configSlice.reducer;
